import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import Calendar from 'react-calendar';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
// import "../../css/yemae.css";
// import "react-date-picker/dist/DatePicker.css";
// import "react-calendar/dist/Calendar.css";
import '../css/calendar.css';
import axios from 'axios';
import moment from 'moment';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { Modal } from 'react-responsive-modal';
import { isMobile } from 'react-device-detect';
import '../css/media_m.css';

const initState = {
  colSerial: 0,
  colImg: '',
  colTitle: '',
  collaboLocationCode: 'Z',
  collaboList: [],
  collaboMenuList: [],
  selectMenuList: [],
  reserveCode: 0,
  colStartDate: '1999-01-01 00:00:00',
  colEndDate: '1999-01-01 00:00:00',
  rdate: '0',
  rtime: '0',
  rtimeName: '',
  //   rlocation: '0',
  rcount: '0',
  payType: '',
  remainNum: 90,
  totalSumPrice: 0,
};

const CollaboReserve = (props) => {
  // console.log(props);
  const { nicName, icon, apiUrl, loginId, setQuickMenu, history, imgUrl } =
    props;
  const [value, setValue] = useState(null);
  const [calShow, setCalShow] = useState(false);
  const [state, setState] = useState(initState);
  const [locationInfo, setLocationInfo] = useState([]);
  const [timetable, setTimetable] = useState([]);

  const _getData = async () => {
    const result = await axios.get(apiUrl + '/collaboReserveLocation');
    const intReturn = result.data[0].intReturn;
    const data = result.data[0].listData;
    console.log(result);
    if (intReturn === 0) {
      setLocationInfo(data);
    }
  };
  const _init = () => {
    setState({
      ...state,
      colSerial: 0,
      colImg: '',
      colTitle: '',
      collaboLocationCode: 'Z',
      collaboList: [],
      collaboMenuList: [],
      selectMenuList: [],
      reserveCode: 0,
      colStartDate: '1999-01-01 00:00:00',
      colEndDate: '1999-01-01 00:00:00',
      rdate: '0',
      rtime: '0',
      rtimeName: '',
      //   rlocation: '0',
      rcount: '0',
      payType: '',
      remainNum: 90,
      totalSumPrice: 0,
    });
    setValue(null);
  };

  const _selectShop = async (collaboLocationCode) => {
    const result = await axios.post(apiUrl + '/collaboReserveSelectShop', {
      collaboLocationCode,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setState({
        ...state,
        colSerial: 0,
        colImg: '',
        colTitle: '',
        collaboMenuList: [],
        selectMenuList: [],
        reserveCode: 0,
        colStartDate: '1999-01-01 00:00:00',
        colEndDate: '1999-01-01 00:00:00',
        rdate: '0',
        rtime: '0',
        rtimeName: '',
        //   rlocation: '0',
        rcount: '0',
        payType: '',
        remainNum: 90,
        totalSumPrice: 0,

        collaboLocationCode: collaboLocationCode,
        collaboList: result.data[0].listData,
      });
      setValue(null);
    } else {
      toast.warn('예약을 진행중인 콜라보 카페가 없습니다.');
      _init();
    }
  };

  const _selectCollabo = async (
    colSerial,
    reserveCode,
    colStartDate,
    colEndDate,
    reserveTitle
  ) => {
    console.log(colSerial);
    const { collaboLocationCode } = state;
    const result = await axios.post(apiUrl + '/collaboReserveMenuList', {
      colSerial,
      collaboLocationCode,
      reserveCode,
    });

    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      setState({
        ...state,
        selectMenuList: [],
        rdate: '0',
        rtime: '0',
        rtimeName: '',
        //   rlocation: '0',
        rcount: '0',
        payType: '',
        remainNum: 90,
        totalSumPrice: 0,
        collaboMenuList: result.data[0].listData,
        colImg: result.data[0].listData[0].img,
        colTitle: reserveTitle,
        colSerial,
        reserveCode,
        colStartDate,
        colEndDate,
      });
    } else {
      alert('콜라보 메뉴 정보를 불러오지 못했습니다.');
      _init();
    }
  };

  const _selectTime = (rtime, remainNum, rtimeName) => {
    console.log(rtime, remainNum);
    setState({
      ...state,
      rtime: rtime.toString(),
      rtimeName: rtimeName,
      //   rlocation: 1,
      rcount: '0',
      payType: '',
      selectMenuList: [],
      remainNum: remainNum,
    });
  };

  const _selectNum = (rcount) => {
    if (rcount > state.remainNum) {
      toast.error('남은 예약수량을 초과했습니다.');
    } else {
      setState({
        ...state,
        rcount: rcount,
        payType: '',
      });

      _chkSale(rcount);
    }
  };

  const _selectPay = (payType) => {
    setState({
      ...state,
      payType: payType,
    });
  };

  //   const _onChange = (e) => {
  //     if (e.target.name === 'rtime') {
  //       setState({
  //         ...state,
  //         rtime: e.target.value,
  //         // rlocation: '0',
  //         rcount: '0',
  //         payType: '',
  //       });
  //     }
  //     if (e.target.name === 'rlocation') {
  //       setState({
  //         ...state,
  //         rlocation: e.target.value,
  //         rcount: '0',
  //         payType: '',
  //       });
  //     }

  //     if (e.target.name === 'rcount') {
  //       setState({
  //         ...state,
  //         rcount: e.target.value,
  //         payType: '',
  //       });
  //       _chkSale(e.target.value);
  //     }
  //     if (e.target.name === 'payType') {
  //       setState({
  //         ...state,
  //         payType: e.target.value,
  //       });
  //     }
  //   };

  const _chkSale = async (rcount) => {
    const { reserveCode, rdate, rtime, collaboLocationCode } = state;
    const result = await axios.post(apiUrl + '/collaboReserveCheckSale', {
      reserveCode,
      rdate,
      rtime,
      collaboLocationCode,
      rcount,
    });

    const intReturn = result.data[0].intReturn;
    console.log(intReturn);
    if (intReturn === 0) {
    } else {
      alert('예약가능 수량을 초과하였습니다.');
      setState({
        ...state,
        rcount: '0',
        selectMenuList: [],
        payType: '',
      });
    }
  };

  const _onDateClick = (value, event) => {
    const rvalue = moment(value).format('YYYYMMDD');

    setState({
      ...state,
      rdate: rvalue,
      rtime: '0',
      rtimeName: '',
      //rlocation: '0',
      rcount: '0',
      selectMenuList: [],
      payType: '',
    });
    // setCalShow(false);
  };

  const _apply = async () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // if (loginId !== 'admin') {
    //   if (today < '2023-11-21 10:00:00') {
    //     toast.warn('예매가 시작전입니다.');
    //     return;
    //   }

    //   if (today > '2024-01-07 18:00:00') {
    //     toast.warn('예매가 종료되었습니다.');
    //     return;
    //   }
    // }

    if (loginId === null || loginId === undefined || loginId === '') {
      // Swal.fire({
      //   title: 'Error!',
      //   text: '로그인 후 예매가 가능합니다',
      //   // icon: 'error',
      //   confirmButtonText: ' Cool',
      // });
      // Swal.fire('SweetAlert2 is working!');
      // alert('로그인 후 예매가 가능합니다.');
      toast.warn('로그인 후 예매가 가능합니다.');
      return false;
    }
    if (state.collaboLocationCode === 'Z') {
      toast.warn('매장을 선택하세요');
      // alert('예매 일자를 선택하세요');
      return false;
    }
    if (state.reserveCode === 0) {
      toast.warn('콜라보 카페를 선택하세요');
      // alert('예매 일자를 선택하세요');
      return false;
    }
    if (state.rdate === '0') {
      toast.warn('예약 일자를 선택하세요');
      // alert('예매 일자를 선택하세요');
      return false;
    }
    if (state.rtime === '0') {
      toast.warn('예약 시간을 선택하세요');
      // alert('예매 회차를 선택하세요');
      return false;
    }
    // if (state.rlocation === '0') {
    //   toast.warn('상영장소를 선택하세요');
    //   // alert('예매 장소를 선택하세요');
    //   return false;
    // }
    if (state.rcount === '0') {
      toast.warn('예약 인원수를 선택하세요');
      // alert('예매 수를 선택하세요');
      return false;
    }
    if (state.selectMenuList.length <= 0) {
      toast.warn('메뉴를 선택하세요');
      // alert('예매 수를 선택하세요');
      return false;
    }
    if (state.payType === '') {
      toast.warn('결제 방법을 선택하세요.');
      // alert('결제수단을 선택하세요.');
      return false;
    }

    // const { rdate, rtime, rlocation, rcount } = state;
    // const price = rcount * exhibitionInfo[0].price;
    _pay();
  };

  const _pay = async () => {
    const cKey = 'test_ck_qLlDJaYngrooqgwBpNmrezGdRpXx';
    // const cKey = 'live_ck_d26DlbXAaV0P42ERJN0VqY50Q9RB';

    const {
      colSerial,
      colTitle,
      reserveCode,
      selectMenuList,
      rdate,
      rtime,
      collaboLocationCode,
      rcount,
      payType,
    } = state;
    const amount = paySumPrice();
    console.log(amount);
    console.log(selectMenuList);

    let menuParam = '';

    if (selectMenuList.length > 0) {
      selectMenuList.map(
        (item) => (menuParam = menuParam + item.menuCode + '|' + item.num + ',')
      );
    } else {
      alert('예약 메뉴가 누락되었습니다.');
    }

    console.log(menuParam);
    const orderCode = _makeOrderCode();
    const toasspayments = await loadTossPayments(cKey);
    const orderName = colTitle + ' ' + rcount + '건 예약';
    console.log(orderCode);
    const result = await axios.post(apiUrl + '/collaboReservePayPre', {
      reserveCode,
      orderCode,
      loginId,
      rdate,
      rtime,
      collaboLocationCode,
      rcount,
      amount,
      menuParam,
      payType,
    });

    const intReturn = result.data[0].intReturn;
    console.log(intReturn);
    if (intReturn === 0) {
      console.log(intReturn);
      if (
        payType === '네이버페이' ||
        payType === '카카오페이' ||
        payType === '토스페이'
      ) {
        await toasspayments.requestPayment('간편결제', {
          amount: amount,
          orderId: orderCode,
          orderName: orderName,
          customerName: loginId,
          successUrl: `${window.location.origin}/rsucc`,
          failUrl: `${window.location.origin}/rfail`,
          flowMode: 'DIRECT',
          easyPay: payType,
        });
      } else {
        await toasspayments.requestPayment(payType, {
          amount: amount,
          orderId: orderCode,
          orderName: orderName,
          customerName: loginId,
          successUrl: `${window.location.origin}/rsucc`,
          failUrl: `${window.location.origin}/rfail`,
          // variantKey: "DEFAULT",
        });
      }
    } else if (intReturn === -2) {
      toast.warn('중복된 결제 정보입니다.');
    } else if (intReturn === -1) {
      toast.warn('예매가 종료되거나 존재하지 않는 콜라보입니다.');
    } else if (intReturn === -100) {
      toast.warn('한정메뉴가 품절 되었거나 구매 수량을 초과하였습니다.');
    } else if (intReturn === -200) {
      toast.warn('선택한 시간의 예약 인원을 초과하였습니다.');
    } else {
      toast.error('결제중 오류가 발생했습니다.');
    }

    // const cKey = 'test_ck_qLlDJaYngrooqgwBpNmrezGdRpXx';

    //   const cKey = 'live_ck_d26DlbXAaV0P42ERJN0VqY50Q9RB';
    //   const { rdate, rtime, rlocation, rcount, payType } = state;
    //   const amount = rcount * exhibitionInfo[0].price;
    //   const exhibitionCode = exhibitionInfo[0].exhibitionCode;
    //   const startDate = exhibitionInfo[0].startDate;
    //   const endDate = exhibitionInfo[0].endDate;
    //   const limitNum = exhibitionInfo[0].limitNum;

    //   const orderId = _makeOrderCode();
    //   const toasspayments = await loadTossPayments(cKey);
    //   const orderName =
    //     exhibitionInfo[0].exhibitionName + ' ' + rcount + '건 예매';
    //   // console.log(orderId);

    //   const result = await axios.post(apiUrl + '/exhibitionPayPre', {
    //     exhibitionCode,
    //     rdate,
    //     rtime,
    //     rlocation,
    //     rcount,
    //     orderId,
    //     loginId,
    //     amount,
    //     payType,
    //   });

    //   const intReturn = result.data[0].intReturn;
    //   if (intReturn === 0) {
    //     if (
    //       payType === '네이버페이' ||
    //       payType === '카카오페이' ||
    //       payType === '토스페이'
    //     ) {
    //       await toasspayments.requestPayment('간편결제', {
    //         amount: amount,
    //         orderId: orderId,
    //         orderName: orderName,
    //         customerName: loginId,
    //         successUrl: `${window.location.origin}/tsucc`,
    //         failUrl: `${window.location.origin}/tfail`,
    //         flowMode: 'DIRECT',
    //         easyPay: payType,
    //       });
    //     } else {
    //       await toasspayments.requestPayment(payType, {
    //         amount: amount,
    //         orderId: orderId,
    //         orderName: orderName,
    //         customerName: loginId,
    //         successUrl: `${window.location.origin}/tsucc`,
    //         failUrl: `${window.location.origin}/tfail`,
    //         // variantKey: "DEFAULT",
    //       });
    //     }
    //   } else if (intReturn === -1) {
    //     /*주문번호 중복*/
    //     // alert("중복된 결제 정보입니다.");
    //     toast.error('중복된 결제 정보입니다.');
    //   } else if (intReturn === -2) {
    //     /*회차별 인원제한 */
    //     toast.error('회차당 입장 객수가 초과되었습니다.');
    //     // alert("회차당 입장수를 초과하였습니다.");
    //   } else if (intReturn === -3) {
    //     /*예매 시작전 또는 예매 종료 */
    //     toast.error('예매가 시작전이거나 예매가 종료되었습니다.');
    //     // alert("예매가 시작전이거나 예매가 종료되었습니다.");
    //   } else if (intReturn === -5) {
    //     /*예매 시작전 또는 예매 종료 */
    //     toast.error('회차당 인당 최대 예매수 4장을 초과하였습니다.');
    //     // alert("예매가 시작전이거나 예매가 종료되었습니다.");
    //   }
  };

  const _makeOrderCode = () => {
    let date = new Date();
    let f = 'a';
    let m = 1;
    let arr =
      '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z'.split(
        ','
      );
    let newarr = new Array(m);
    let tmp = '';
    let flag = false;
    for (let i = 0; i < m; i++) {
      tmp = '';
      flag = false;
      for (let j = 0; j < 7; j++) {
        tmp += arr[Math.floor(Math.random() * arr.length)];
      }
      for (let k = 0; k < i; k++) {
        if (newarr[k] == f + tmp) {
          flag = true;
          i--;
          break;
        }
      }
      if (!flag) newarr[i] = f + tmp;
    }
    let temp = moment(date).format('YYYYMMDDhhmmss');

    return temp + '_' + loginId.substring(0, 4) + '_' + newarr[0];
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _rdateChange = (value, event) => {
    setValue(value);
    _getTimetable(state.reserveCode, value);
  };

  const _getTimetable = async (reserveCode, value) => {
    // const exhibitionCode = exhibitionInfo[0].exhibitionCode;
    const rdate = moment(value).format('YYYYMMDD');
    // console.log(exhibitionCode, rdate);
    const result = await axios.post(apiUrl + '/collaboReserveTimetable', {
      reserveCode,
      rdate,
    });

    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;
    if (intReturn === 0) {
      setTimetable(listData);
    } else {
      setTimetable([]);
    }
  };
  const _list = () => {
    history.push('/crlist');
  };
  const _back = () => {
    history.goBack();
  };
  const _toggleMenu = () => {
    document.getElementById('ul').classList.toggle('active');
  };

  const _selectMenu = async (
    menuCode,
    menuName,
    price,
    menuGubun,
    sellCount,
    limitMenuNum
  ) => {
    //메뉴배열
    document.getElementById('ul').classList.toggle('active');
    const { collaboLocationCode, reserveCode } = state;
    let isMenu = true;
    if (menuGubun === 'L') {
      if (sellCount >= limitMenuNum) {
        isMenu = false;
      } else {
        const result = await axios.post(
          apiUrl + '/collaboReserveLimitMenuCheck',
          {
            menuCode,
            collaboLocationCode,
            menuNum: 1,
            reserveCode,
          }
        );
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
        } else {
          isMenu = false;
        }
      }
    }
    //한정 메뉴일 경우 DB에서 품절여부 한번더 확인.

    if (isMenu) {
      const selectMenu = {
        menuCode: menuCode,
        menuName: menuName,
        menuGubun: menuGubun,
        price: price,
        num: 1,
        sumPrice: price * 1,
      };
      const isExits = state.selectMenuList.includes(selectMenu);
      const menus = state.selectMenuList;
      menus.push(selectMenu);

      if (!isExits) {
        setState({
          ...state,
          selectMenuList: menus,
        });
      }
    } else {
      alert('한정메뉴가 품절 되었습니다.');
    }
  };

  const _numAddChange = async (menuCode, menuGubun) => {
    const { collaboLocationCode, reserveCode } = state;
    const menus = state.selectMenuList;
    const index = menus.findIndex((item) => item.menuCode === menuCode);
    const { rcount } = state;
    console.log(menuCode, menuGubun, rcount);
    let buyLimit = 10;
    let isMenu = true;
    if (menuGubun === 'L') {
      buyLimit = rcount;

      const result = await axios.post(
        apiUrl + '/collaboReserveLimitMenuCheck',
        {
          menuCode,
          collaboLocationCode,
          menuNum: menus[index].num + 1,
          reserveCode,
        }
      );

      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
      } else {
        isMenu = false;
      }
    }

    //한정 메뉴일 경우 DB에서 품절여부 한번더 확인.

    if (isMenu && menus[index].num < buyLimit) {
      const addNum = menus[index].num + 1;
      menus[index].num = addNum;
      menus[index].sumPrice = addNum * menus[index].price;

      setState({
        ...state,
        selectMenuList: menus,
      });
    } else {
      if (menuGubun === 'L') {
        alert('한정 메뉴의 경우 인당 1개만 주문 할 수 있습니다.');
      } else {
        alert('메뉴당 10개를 초과할 수 없습니다.');
      }
    }
  };

  const _numMinChange = (menuCode) => {
    const menus = state.selectMenuList;
    const index = menus.findIndex((item) => item.menuCode === menuCode);
    // console.log(index, menuCode);
    if (menus[index].num > 1) {
      const minNum = menus[index].num - 1;
      menus[index].num = minNum;
      menus[index].sumPrice = minNum * menus[index].price;

      setState({
        ...state,
        selectMenuList: menus,
      });
    } else {
      alert('메뉴당 주문 최소수량은 1개 이상입니다.');
    }
  };

  const _deleteMenu = (menuCode) => {
    const menus = state.selectMenuList;
    const index = menus.findIndex((item) => item.menuCode === menuCode);

    menus.splice(index, 1);
    setState({
      ...state,
      selectMenuList: menus,
    });
  };

  const paySumPrice = () => {
    let totalSumPrice = 0;

    if (state.selectMenuList.length > 0) {
      state.selectMenuList.map((item) => {
        totalSumPrice = totalSumPrice + item.sumPrice;
      });
    }
    return totalSumPrice;
  };

  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData();
    }
  }, []);

  //   console.log(state);

  //   if (exhibitionInfo.length <= 0) {
  //     return <div></div>;
  //   }

  //   console.log(
  //     new Date('2024-01-01').getDate(),
  //     new Date('2024-01-01').getMonth(),
  //     new Date('2024-01-01').getFullYear()
  //   );
  return (
    <>
      <div id="wrap">
        <a className="close" onClick={_back} style={{ cursor: 'pointer' }}></a>
        {/* <!-- 컨텐츠영역 --> */}
        <section className="container5 tiket1">
          <a className="close1" onClick={_list} style={{ cursor: 'pointer' }}>
            예약 내역
          </a>
          {/* <!-- 왼쪽 컨텐츠 --> */}
          <div className="bx bx_left">
            {/* <!-- 모바일용  --> */}
            <h1>
              <img
                src={'https://file.aniplustv.com/TShop/collabo/' + state.colImg}
                style={{ borderRadius: '10px' }}
                alt=""
              />
              <div className="colTitle">{state.colTitle}</div>
            </h1>
            {/* <!-- //모바일용 --> */}
            <div className="section">
              <div className="reserve scroll">
                <div className="tab_section">
                  <ul className="tab">
                    <li className="on" data-tab="tabmenu1">
                      <a>
                        step 1.<span>매장 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>콜라보 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>시간 선택</span>
                      </a>
                    </li>
                    {/*
                    <li data-tab="tabmenu5">
                      <a>
                        step 5.<span>매수</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu6">
                      <a>
                        step 4.<span>결제방식</span>
                      </a>
                    </li> */}
                  </ul>
                  <div id="tabmenu1" className="tabcont on">
                    <ul className="select">
                      {locationInfo.map((item) => (
                        <li
                          className={
                            item.collaboLocationCode ===
                            state.collaboLocationCode
                              ? 'active'
                              : item.collaboLocationCode === item.active
                              ? 'inactive'
                              : 'noactive'
                          }
                          onClick={() => _selectShop(item.collaboLocationCode)}
                        >
                          <a>{item.collaboLocationName}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>매장 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2" className="on">
                      <a>
                        step 2.<span>콜라보 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>시간 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu2" className="tabcont on">
                    <ul className="select1">
                      {state.collaboList.length > 0 ? (
                        state.collaboList.map((item) => (
                          <li
                            key={item.reserveCode}
                            className={
                              item.reserveCode === state.reserveCode
                                ? 'active'
                                : null
                            }
                            onClick={() =>
                              _selectCollabo(
                                item.colSerial,
                                item.reserveCode,
                                item.colStartDate,
                                item.colEndDate,
                                item.reserveTitle
                              )
                            }
                          >
                            <a>{item.reserveTitle}</a>
                          </li>
                        ))
                      ) : (
                        <li>
                          <a>예약할 매장을 먼저 선택해 주세요.</a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>매장 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>콜라보 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3" className="on">
                      <a>
                        step 3.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>시간 선택</span>
                      </a>
                    </li>
                  </ul>

                  <div id="tabmenu3" className="tabcont on">
                    <div>
                      <Calendar
                        onChange={_rdateChange}
                        className="calClass"
                        onClickDay={_onDateClick}
                        value={value}
                        minDate={
                          new Date() > new Date(state.colStartDate)
                            ? new Date()
                            : new Date(state.colStartDate)
                        }
                        maxDate={
                          new Date(moment(state.colEndDate).add(-1, 'day'))
                        }
                        formatDay={(locale, date) => moment(date).format('D')}
                        tileDisabled={({ date, view }) =>
                          date.getDate() === 1 &&
                          date.getMonth() === 0 &&
                          date.getFullYear() === 2024
                        }
                      />
                    </div>
                    <ul className="calendar_ty">
                      <li className="ty1">예매가능한 날짜</li>
                      <li className="ty2">선택하신 날짜</li>
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>매장 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>콜라보 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4" className="on">
                      <a>
                        step 4.<span>시간 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu2" className="tabcont">
                    <ul className="select">
                      {timetable.map((item, index) => (
                        <li
                          className={
                            state.rtime === item.rtime.toString() && 'active'
                          }
                          onClick={() =>
                            _selectTime(
                              item.rtime,
                              item.remainNum,
                              item.rtimeName
                            )
                          }
                        >
                          {item.remainNum <= 0 ? (
                            <span>{item.rtimeName}</span>
                          ) : (
                            <a href="#">
                              {item.rtimeName}
                              {item.remainNum < 10 &&
                                ' (' + item.remainNum + '인 남음)'}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1" className="on">
                      <a>
                        step 5.<span>인원 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 6.<span>메뉴 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 7.<span>결제방식 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>{/* step 4.<span>결제방식 선택</span> */}</a>
                    </li>
                  </ul>
                  <div id="tabmenu3" className="tabcont">
                    <p className="refer">※ 한 회당 최대 2인까지 선택 가능</p>
                    <ul className="select select_cnt">
                      <li className={state.rcount === 1 && 'active'}>
                        {state.remainNum >= 1 ? (
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => _selectNum(1)}
                          >
                            1인
                          </a>
                        ) : (
                          <span>1인</span>
                        )}
                      </li>
                      <li className={state.rcount === 2 && 'active'}>
                        {state.remainNum >= 2 ? (
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => _selectNum(2)}
                          >
                            2인
                          </a>
                        ) : (
                          <span>2인</span>
                        )}
                      </li>
                      <li></li>
                      <li></li>
                      {/* <li className={state.rcount === 3 && 'active'}>
                        {state.remainNum >= 3 ? (
                          <a href="#" onClick={() => _selectNum(3)}>
                            3매
                          </a>
                        ) : (
                          <span>3매</span>
                        )}
                      </li>
                      <li className={state.rcount === 4 && 'active'}>
                        {state.remainNum >= 4 ? (
                          <a href="#" onClick={() => _selectNum(4)}>
                            4매
                          </a>
                        ) : (
                          <span>4매</span>
                        )}
                      </li> */}
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 5.<span>인원 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2" className="on">
                      <a>
                        step 6.<span>메뉴 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 7.<span>결제방식 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>{/* step 4.<span>결제방식 선택</span> */}</a>
                    </li>
                  </ul>
                  <div id="tabmenu4" className="tabcont">
                    <div id="select-wrap">
                      <div
                        id="select"
                        className="selectbox"
                        onClick={_toggleMenu}
                      >
                        메뉴를 선택해 주세요
                      </div>

                      <ul id="ul" className="select-ul">
                        {state.collaboMenuList.map((item) => (
                          <li
                            onClick={() =>
                              _selectMenu(
                                item.menuCode,
                                item.menuName,
                                item.price,
                                item.menuGubun,
                                item.sellCount,
                                item.limitMenuNum
                              )
                            }
                          >
                            {item.menuGubun === 'L' ? (
                              item.sellCount >= item.limitMenuNum ? (
                                <span className="soldout">[품절]</span>
                              ) : (
                                ''
                              )
                            ) : (
                              ''
                            )}
                            {item.menuName}{' '}
                            {item.menuGubun === 'L' ? (
                              <spna className="limitMenu">[한정메뉴]</spna>
                            ) : (
                              ''
                            )}
                            <br />
                            <span className="menuSubTitle">
                              {item.menuComment}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <ul className="select2">
                      {state.selectMenuList.map((item) => (
                        <li key={item.menuCode}>
                          <div className="menu-header">
                            <div className="menuName">{item.menuName}</div>
                            <div
                              onClick={() => _deleteMenu(item.menuCode)}
                              style={{ cursor: 'pointer' }}
                            >
                              삭제
                            </div>
                          </div>
                          <div className="menu-controls">
                            <div>
                              <em onClick={() => _numMinChange(item.menuCode)}>
                                -
                              </em>
                              <input type="number" value={item.num} readOnly />
                              개
                              <em
                                onClick={() =>
                                  _numAddChange(item.menuCode, item.menuGubun)
                                }
                              >
                                +
                              </em>
                            </div>
                            <div>{CommaFormatted(item.num * item.price)}원</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 5.<span>인원 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 6.<span>메뉴 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3" className="on">
                      <a>
                        step 7.<span>결제방식 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>{/* step 4.<span>결제방식 선택</span> */}</a>
                    </li>
                  </ul>
                  <div id="tabmenu4" className="tabcont">
                    <ul className="select">
                      <li className={state.payType === '카드' && 'active'}>
                        <a href="#" onClick={() => _selectPay('카드')}>
                          신용카드
                        </a>
                      </li>
                      <li className={state.payType === '계좌이체' && 'active'}>
                        <a href="#" onClick={() => _selectPay('계좌이체')}>
                          계좌이체
                        </a>
                      </li>
                      <li
                        className={state.payType === '네이버페이' && 'active'}
                      >
                        <a href="#" onClick={() => _selectPay('네이버페이')}>
                          네이버 페이
                        </a>
                      </li>
                      <li
                        className={state.payType === '카카오페이' && 'active'}
                      >
                        <a href="#" onClick={() => _selectPay('카카오페이')}>
                          카카오 페이
                        </a>
                      </li>
                      <li className={state.payType === '토스페이' && 'active'}>
                        <a href="#" onClick={() => _selectPay('토스페이')}>
                          토스 페이
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="noti">
                  <div className="noti_tit">유의사항</div>
                  <ol>
                    <li>
                      1. 예약 구매에 대한 취소 및 환불은 예약하신 일자의 2일
                      전까지만 가능하며 이후에는 취소가 절대 불가능하오니 신중한
                      예약을 부탁 드립니다.
                    </li>
                    <li>
                      2. 예약 회차 변경 시에는 예약 취소 후, 재예약을 부탁
                      드립니다.
                    </li>
                    <li>
                      3.예약자는 본 예약 상세페이지의 모든 내용을 숙지 및 동의한
                      것으로 간주합니다. (안내 미숙지로 인한 책임은 예약자
                      본인에게 있으며, 이로 인한 취소, 변경, 환불은 불가합니다.)
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 오른쪽 컨텐츠 --> */}
          <div className="col bx_right">
            <div
              className="bx bx1"
              style={
                isMobile
                  ? {
                      position: 'fixed',
                      bottom: 0,
                      width: '100%',
                      backgroundColor: '#fff',
                    }
                  : {}
              }
            >
              {/* <!-- 웹용 --> */}
              <h1>
                <img
                  src={
                    'https://file.aniplustv.com/TShop/collabo/' + state.colImg
                  }
                  style={{ borderRadius: '10px' }}
                  alt=""
                />
                <div className="colTitle">{state.colTitle}</div>
              </h1>

              {/* <!-- //웹용 --> */}
              <div className="section_fot">
                <div className="totalinfo" style={{ paddingBottom: 10 }}>
                  <dl>
                    <dt>장소</dt>
                    <dd>
                      {' '}
                      {state.collaboLocationCode === 'A'
                        ? '서울 합정점'
                        : state.collaboLocationCode === 'B'
                        ? '대전 중앙로점'
                        : state.collaboLocationCode === 'C'
                        ? '광주 충장로점'
                        : state.collaboLocationCode === 'D'
                        ? '부산 서면점'
                        : ''}
                    </dd>
                  </dl>
                  <dl>
                    <dt>콜라보 카페</dt>
                    <dd>{state.colTitle}</dd>
                  </dl>
                </div>
                <div className="totalinfo">
                  <dl>
                    <dt>날짜</dt>
                    <dd>
                      {' '}
                      {state.rdate === '0'
                        ? ''
                        : moment(
                            state.rdate.substring(0, 4) +
                              '-' +
                              state.rdate.substring(4, 6) +
                              '-' +
                              state.rdate.substring(6, 8)
                          ).format('YYYY.MM.DD(dd)')}
                    </dd>
                  </dl>
                  <dl>
                    <dt>시간</dt>
                    <dd>{state.rtime === '0' ? '' : state.rtimeName}</dd>
                  </dl>
                  <dl>
                    <dt>수량</dt>
                    <dd>{state.rcount}매</dd>
                  </dl>
                </div>
                <div className="totalprice">
                  <dl>
                    <dt>최종 결제금액</dt>
                    <dd>{CommaFormatted(paySumPrice())}원</dd>
                  </dl>
                </div>

                <div className="btn_area">
                  <a onClick={_apply} style={{ cursor: 'pointer' }}>
                    예약하기
                  </a>
                </div>
              </div>
            </div>
            <div className="bx bx2">
              <div className="totalinfo" style={{ paddingBottom: 10 }}>
                <dl>
                  <dt>장소</dt>
                  <dd>
                    {' '}
                    {state.collaboLocationCode === 'A'
                      ? '서울 합정점'
                      : state.collaboLocationCode === 'B'
                      ? '대전 중앙로점'
                      : state.collaboLocationCode === 'C'
                      ? '광주 충장로점'
                      : state.collaboLocationCode === 'D'
                      ? '부산 서면점'
                      : ''}
                  </dd>
                </dl>
                <dl>
                  <dt>콜라보 카페</dt>
                  <dd>{state.colTitle}</dd>
                </dl>
              </div>
              <div className="totalinfo">
                <dl>
                  <dt>날짜</dt>
                  <dd>
                    {' '}
                    {state.rdate === '0'
                      ? ''
                      : moment(
                          state.rdate.substring(0, 4) +
                            '-' +
                            state.rdate.substring(4, 6) +
                            '-' +
                            state.rdate.substring(6, 8)
                        ).format('YYYY.MM.DD(dd)')}
                  </dd>
                </dl>
                <dl>
                  <dt>시간</dt>
                  <dd>{state.rtime === '0' ? '' : state.rtimeName}</dd>
                </dl>
                <dl>
                  <dt>인원</dt>
                  <dd>{state.rcount}인</dd>
                </dl>
              </div>
              <div className="totalprice">
                <dl>
                  <dt>최종 결제금액</dt>
                  <dd>{CommaFormatted(paySumPrice())}원</dd>
                </dl>
              </div>
              <div className="btn_area">
                <a onClick={_apply} style={{ cursor: 'pointer' }}>
                  예약하기
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default shopContext(withRouter(CollaboReserve));
